// @ts-check
import { getSourceClick, readAttribution, readSession } from '@/lib/marketing/helpers';

/**
 * Google's own snippet, rewritten as plain code: it is the same two steps, with the `&l=` branch
 * dropped because it only ever applies to a data layer not called `dataLayer`.
 *
 * The container reads whatever is already in the data layer when it loads, so `gtm.start` goes in
 * before the script is inserted.
 *
 * @param {string} containerId
 */
function loadGTM(containerId) {
  enqueue({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${containerId}`;

  const firstScript = document.getElementsByTagName('script')[0];
  firstScript.parentNode?.insertBefore(script, firstScript);
}

/** @param {Record<string, unknown>} event */
function enqueue(event) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(event);
}

function run() {
  enqueue({
    event: 'default_consent',
    'gtm.consentMode': 'default',
    ad_storage: 'denied',
    analytics_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
  });

  enqueue({
    event: 'consent_update',
    'gtm.consentMode': 'update',
    ad_storage: 'granted',
    analytics_storage: 'granted',
    ad_user_data: 'granted',
    ad_personalization: 'granted',
  });

  /** @type {Record<string, string>} */
  const CONTAINERS = {
    'staging.johnsonlawgroup.com': 'GTM-TH633F88',
    'johnsonlawgroup.com': 'GTM-PGKS42BM',
    default: 'GTM-PGKS42BM',
  };

  loadGTM(CONTAINERS[location.host] ?? CONTAINERS['default']);
}

export function pushSessionParams() {
  const { campaignId, offerId, leadTypeId, leadTypeName, leadSource } = readAttribution();

  enqueue({
    session_id: readSession().sessionId,
    leadTypeId,
    leadTypeName,
    cid: campaignId,
    oid: offerId,
    lead_source: leadSource,
    version: '2',
    ...getSourceClick(),
  });
}

export { run, enqueue };
